import { get } from "lodash";

export const getSelectedLocations = (state) =>
  get(state, ["ui", "locationFilter", "selected"]);

export const getLocationsFilterOptions = (state) => {
  return get(state, ["ui", "locationFilter", "options"], []);
};

export const getSelectedLocationDescription = (state) => {
  const locationOptions = getLocationsFilterOptions(state);
  const selectedLocations = getSelectedLocations(state);

  if (locationOptions.length == 0) {
    return "All locations";
  }

  if (locationOptions.length === 1) {
    return locationOptions[0].name;
  }

  if (selectedLocations.length == 0) {
    return "All locations";
  }

  if (selectedLocations.length === locationOptions.length) {
    return "All locations";
  }

  if (selectedLocations.length === 1) {
    return (
      locationOptions.find(
        (location) => location.locationCode == selectedLocations[0]
      )?.name || "1 location"
    );
  }

  return `${selectedLocations.length} locations`;
};
